export const formatMetadata = (metadataFields, savedKeyValue) => {
  let metadataKeyValue = {};
  metadataFields.forEach((field) => {
    metadataKeyValue[field] = savedKeyValue[field] || null;
  });

  return metadataKeyValue;
};

export const updateEditableLabel = (prev, key, updatedLabel) => {
  const updatedLabelObj = {
    ...prev,
  };
  // if the label has not been updated yet, add to the object
  if (!updatedLabelObj[key]) {
    updatedLabelObj[key] = {};
    updatedLabelObj[key][updatedLabel] = null;
  } else {
    // if the label/value pair for the key already exists, replace the label name
    const valueForLabel = Object.values(updatedLabelObj[key])[0];
    updatedLabelObj[key] = {};
    updatedLabelObj[key][updatedLabel] = valueForLabel;
  }

  return updatedLabelObj;
};

export const updateValueForLabel = (prev, key, updatedValue) => {
  const updatedLabelObj = {
    ...prev,
    [key]: {
      ...prev[key],
    },
  };
  const existingLabel = Object.keys(updatedLabelObj[key])[0];
  updatedLabelObj[key][existingLabel] = updatedValue;

  return updatedLabelObj;
};

export const extractMetadataInfo = (nestedObj) => {
  let metadata = {};

  for (const key in nestedObj) {
    Object.assign(metadata, nestedObj[key]);
  }

  return metadata;
};

export const extractMetadataPrivacy = (inputValues, privacyValues) => {
  const privacy = {};
  for (const key in inputValues) {
    const label = Object.keys(inputValues[key] || {})[0];
    if (label) {
      privacy[label] = !!privacyValues[key];
    }
  }
  return privacy;
};

export const hasEmptyKeyValue = (newFields, addedMetadata) => {
  const metadataToSave = extractMetadataInfo(addedMetadata);
  return newFields.length > 0
    && (Object.keys(metadataToSave).includes('')
      || Object.values(metadataToSave).includes(null)
      || Object.keys(metadataToSave).length === 0
      || Object.values(metadataToSave).length === 0);
};